/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
} from './PaymentState';

/**
 * 
 * @export
 * @interface RetriedPaymentDto
 */
export interface RetriedPaymentDto {
    /**
     * 
     * @type {PaymentState}
     * @memberof RetriedPaymentDto
     */
    paymentState: PaymentState;
    /**
     * 
     * @type {string}
     * @memberof RetriedPaymentDto
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof RetriedPaymentDto
     */
    bookingReference: string;
    /**
     * 
     * @type {number}
     * @memberof RetriedPaymentDto
     */
    amount: number;
}

/**
 * Check if a given object implements the RetriedPaymentDto interface.
 */
export function instanceOfRetriedPaymentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentState" in value;
    isInstance = isInstance && "paymentReference" in value;
    isInstance = isInstance && "bookingReference" in value;
    isInstance = isInstance && "amount" in value;

    return isInstance;
}

export function RetriedPaymentDtoFromJSON(json: any): RetriedPaymentDto {
    return RetriedPaymentDtoFromJSONTyped(json, false);
}

export function RetriedPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetriedPaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentState': PaymentStateFromJSON(json['paymentState']),
        'paymentReference': json['paymentReference'],
        'bookingReference': json['bookingReference'],
        'amount': json['amount'],
    };
}

export function RetriedPaymentDtoToJSON(value?: RetriedPaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentState': PaymentStateToJSON(value.paymentState),
        'paymentReference': value.paymentReference,
        'bookingReference': value.bookingReference,
        'amount': value.amount,
    };
}

